const user = {
  get_user_config: "/api/config/settings",
  update_user_config: "/api/config/settings",
};

const settings = {
  get_tabs: "/api/config/sections",
  get_tenant_config: "/api/config/tenant/settings",
};

const watchlist = {
  get_device_watchlist: "/api/watchlist/device",
  add_to_watchlist: "/api/watchlist/device",
  delete_from_watchlist: "/api/watchlist/device",
};
export { user, settings, watchlist };
